<app-header></app-header>
<app-leftsidebar></app-leftsidebar>
<main class="listing-form-shell">
<div class="listing-form-page">
  <h1>{{ isEditing ? 'Edit Listing' : 'New Listing' }}</h1>

  @if (loading) {
    <div class="listing-form-loading">Loading&hellip;</div>
  } @else {
    <div class="listing-form-card">
      <label class="field-label">Cover image</label>
      <div class="cover-upload">
        @if (coverImagePreviewUrl) {
          <img class="cover-preview" [src]="coverImagePreviewUrl" alt="Cover preview" />
        } @else {
          <div class="cover-preview cover-preview--empty">No image</div>
        }
        <input type="file" accept="image/*" (change)="onCoverImageSelected($event)" />
      </div>

      <label class="field-label">Title</label>
      <input type="text" class="field-input" [(ngModel)]="title" placeholder="Listing title" />

      <label class="field-label">Short description</label>
      <input type="text" class="field-input" [(ngModel)]="shortDescription" placeholder="One line for store tiles" />

      <label class="field-label">Description</label>
      <textarea class="field-input" rows="5" [(ngModel)]="description" placeholder="Full description"></textarea>

      <div class="field-row">
        <div>
          <label class="field-label">Category</label>
          <ng-select class="wt-select" [(ngModel)]="categoryId" [items]="categories"
            bindValue="id" bindLabel="name" placeholder="Uncategorized" [clearable]="true" appendTo="body">
            <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Uncategorized' }}</span></ng-template>
          </ng-select>
        </div>
        <div>
          <label class="field-label">License</label>
          <ng-select class="wt-select" [(ngModel)]="licenseTypeId" [items]="licenseTypes"
            bindValue="id" bindLabel="name" placeholder="None specified" [clearable]="true" appendTo="body">
            <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'None specified' }}</span></ng-template>
          </ng-select>
        </div>
      </div>

      <div class="field-row">
        <div>
          <label class="field-label">Price (USD)</label>
          <input type="number" class="field-input" min="0" step="0.01" [(ngModel)]="price" placeholder="0.00" />
        </div>
        <div>
          <label class="field-label">Status</label>
          <ng-select class="wt-select" [(ngModel)]="status" [clearable]="false" [searchable]="false" appendTo="body"
            [items]="[{ value: 'draft', label: 'Draft (not visible in store)' }, { value: 'published', label: 'Published' }]"
            bindValue="value" bindLabel="label">
          </ng-select>
        </div>
      </div>

      <label class="ai-checkbox">
        <input type="checkbox" [(ngModel)]="aiGenerated" />
        This listing includes AI-generated content
      </label>
      @if (aiGenerated) {
        <label class="field-label">Approximate % AI-generated</label>
        <input type="number" class="field-input" min="0" max="100" [(ngModel)]="aiDisclosurePercent" />
      }

      <button type="button" class="wt-btn-primary" [disabled]="saving" (click)="save()">
        {{ saving ? 'Saving…' : 'Save Listing' }}
      </button>
    </div>
  }
</div>
</main>
<app-footer></app-footer>
